import { createReducer, isFetched, isFetching } from "../../utils/reducer"
import {
	MESSAGES_SET,
	MESSAGES_APPEND,
	MESSAGE_SET,
	MESSAGES_REQUEST,
	MESSAGES_REQUEST_DONE,
	UNREAD_COUNT_SET,
	MESSAGE_MARK_READ,
} from "../actions/messageActions"

const initialState = {
	isFetching: false,
	messages: [],
	currentMessage: null,
	unreadCount: 0,
	pagination: {
		currentPage: 1,
		lastPage: 1,
		total: 0,
	},
}

export const setMessages = (state, data) => {
	return {
		...state,
		messages: data.data || [],
		pagination: {
			currentPage: data.current_page || 1,
			lastPage: data.last_page || 1,
			total: data.total || 0,
		},
	}
}

export const appendMessages = (state, data) => {
	return {
		...state,
		messages: [...state.messages, ...(data.data || [])],
		pagination: {
			currentPage: data.current_page || 1,
			lastPage: data.last_page || 1,
			total: data.total || 0,
		},
	}
}

export const setMessage = (state, data) => {
	return {
		...state,
		currentMessage: data,
	}
}

export const setUnreadCount = (state, count) => {
	return {
		...state,
		unreadCount: count,
	}
}

export const markMessageRead = (state, id) => {
	return {
		...state,
		messages: state.messages.map(msg =>
			msg.id === id ? { ...msg, is_read: true, read_at: new Date().toISOString() } : msg,
		),
		unreadCount: Math.max(0, state.unreadCount - 1),
	}
}

export default createReducer(initialState, {
	[MESSAGES_SET]: setMessages,
	[MESSAGES_APPEND]: appendMessages,
	[MESSAGE_SET]: setMessage,
	[MESSAGES_REQUEST]: isFetching,
	[MESSAGES_REQUEST_DONE]: isFetched,
	[UNREAD_COUNT_SET]: setUnreadCount,
	[MESSAGE_MARK_READ]: markMessageRead,
})
